import React from "react";

const Pdf2Icon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16.255"
      height="20.467"
      viewBox="0 0 18.255 22.467"
    >
      <g id="Group_31173" data-name="Group 31173" transform="translate(-3 -2)">
        <path
          id="Path_17599"
          dataName="Path 17599"
          d="M6.932,18.85H5.808v1.4H6.932a.7.7,0,0,0,0-1.4ZM14.234,2H3V24.467H21.255V9.021ZM8.9,19.693a1.92,1.92,0,0,1-1.966,1.966H5.808v1.4H4.4V17.446H6.932A1.92,1.92,0,0,1,8.9,19.412v.281Zm5.757.7a2.666,2.666,0,0,1-2.668,2.668H10.021V17.446h1.966a2.666,2.666,0,0,1,2.668,2.668V20.4Zm5.2-1.545H17.042v1.4h2.106v1.4H17.042v1.4h-1.4V17.446H19.85Zm0-2.808H4.4V3.4h9.829V9.021H19.85ZM11.987,18.85h-.562v2.808h.562a1.327,1.327,0,0,0,1.4-1.4A1.407,1.407,0,0,0,11.987,18.85Z"
          fill="#fff"
        />
      </g>
    </svg>
  );
};

export default Pdf2Icon;



// WEBPACK FOOTER //
// ./src/assets/Pdf2Icon.jsx